import { logInfo } from '../shared/utils/logging';
import { REGISTERED_APPS } from '../shared/types/Apps';
import { IntelligemsUserData } from '../shared/types/CustomWindow';

export const hasIntelligems = (data: unknown): data is object => {
  return typeof data === 'object' && data !== null;
};

export const hasIntelligemsUser = (
  data: unknown,
): data is IntelligemsUserData => {
  if (!hasIntelligems(data)) {
    return false;
  }

  const maybeUser = (data as any).user;
  return (
    typeof maybeUser === 'object' &&
    maybeUser !== null &&
    typeof maybeUser.igId === 'string'
  );
};

export const getIntelligemsUserId = (
  registeredApps: REGISTERED_APPS,
): string | null => {
  if (hasIntelligemsUser(window.igData)) {
    logInfo('Intelligems user ID found', registeredApps);
    return window.igData.user.igId;
  }

  logInfo('No Intelligems user ID available', registeredApps);
  return null;
};
